interface MentorSection {
  header: string;
  imageUrl: string;
  title: string;
  description: string;
  buttonText: string;
}

export const sectionLessons: MentorSection = {
  header: "Lessons",
  imageUrl:
    "https://mentoro-assets.s3.us-west-1.amazonaws.com/portals/public/participant/mentor/mentorCollectibles.svg",
  title: "Your Most Valuable Lessons Here!",
  description:
    "Collect every lesson that you consider valuable in our platform as you move along your learning path.",
  buttonText: "Start Collecting Lessons Now",
};
